module.exports = __webpack_public_path__ + "static/media/Maf_ContenidoConProposito.2e4f6fae.jpg";